import { BindingCreator } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';

const FIELD_NAME = 'includeVisitsInProgress';

export type IncludeVisitsInProgressCheckboxFieldValue = {
   [FIELD_NAME]: boolean;
};

type IncludeVisitsInProgressCheckboxProps = {
   readonly register: BindingCreator<IncludeVisitsInProgressCheckboxFieldValue, typeof FIELD_NAME>;
};

export const IncludeVisitsInProgressCheckbox = (props: IncludeVisitsInProgressCheckboxProps): JSX.Element => {
   return (
      <Checkbox
         controller={props.register(FIELD_NAME)}
         testId={FIELD_NAME}
         label={statisticsTranslationKeys.formFields.includeVisitsInProgress.label}
      />
   );
};
